module.exports = __webpack_public_path__ + "static/pakmaya-seo-7acdd8a83dd5d0b251c9d233de03c84d.png";